import { useSelector } from 'react-redux'

import { useGetPaidSocialCustomMessages as useGetPaidSocialCustomMessagesShared } from '@lyrahealth-inc/shared-app-logic'

import { getIsCustomerHPIExclusive, getNumberOfSessions } from '../../../data/customer/customerSelectors'

export const useGetPaidSocialCustomMessages = () => {
  const numSessions = useSelector(getNumberOfSessions)
  const isHPIExclusive = useSelector(getIsCustomerHPIExclusive)

  return useGetPaidSocialCustomMessagesShared({ numSessions, isHPIExclusive })
}
